export default {"src":"/_next/static/media/logo.e559a621.svg","height":32,"width":233};